$(document).ready(function () {
  updateCountPrice();

  $(document).on('click', '.custom_input_change', function () {
    const productHandle = $(this).data('prohandle');

    if ($('.subscription-radio').hasClass('rc-radio--active')) {
      window.variantStrings.addToCart = 'Start Autoship';
      const submitButton = document.querySelector('.custom-product-form__submit');
      const label = submitButton?.querySelector('span');
      if (label) label.textContent = window.variantStrings.addToCart;
    }

    window.setTimeout(function () {
      const variantTitle = getSelectedVariantTitle();
      if (productHandle && variantTitle) variantdata(productHandle, variantTitle);
      updateCountPrice();
    }, 0);
  });
});

function getCheckedOptionValue(names) {
  for (const name of names) {
    const value = $('input[name="' + name + '"]:checked').first().val();
    if (value) return value;
  }
  return '';
}

function getSelectedVariantTitle() {
  const count = getCheckedOptionValue(['Count', 'Choose Count:']);
  const size = getCheckedOptionValue(['Size', 'Pad Size']);
  const scent = getCheckedOptionValue(['Scent', 'Choose Scent:', 'Scent:']);
  return [count, size, scent].filter(Boolean).join(' / ');
}

function updateCountPrice() {
  const selected = $('.custom-varinat-input-name:checked').first();
  const priceValue = selected.attr('cuspricecount');
  const quantityValue = selected.val();
  const fallback = $('.count-result-price').attr('getCountAtt');

  if (fallback) $('.custom-count-price-add').text(fallback);
  if (!priceValue || !quantityValue) return;

  const price = Number(priceValue.replace('$', ''));
  const quantity = Number(quantityValue.split(' ')[0]);
  if (!price || !quantity) return;

  const perPiece = (price / quantity).toFixed(2).replace(/(\.00|0)$/, '');
  const displayPrice = perPiece.includes('.') ? perPiece : perPiece + '.0';
  $('.custom-count-price-add').text('($' + displayPrice + '/count)');
}

function escapeVariantMediaAttribute(value) {
  return String(value || '')
    .replace(/&/g, '&amp;')
    .replace(/"/g, '&quot;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function variantdata(productHandle, variantTitle) {
  $.getJSON('/products/' + productHandle + '.js', function (result) {
    const exactMedia = [];
    const sharedMedia = [];
    const normalizedTitle = variantTitle.trim();
    const includeShared = normalizedTitle.includes('23"x36"') && normalizedTitle.endsWith('/ Unscented');

    $.each(result.media, function (_index, media) {
      if (!media.alt || media.alt.indexOf('_') === -1) return;

      const separatorIndex = media.alt.indexOf('_');
      const mediaVariant = media.alt.slice(separatorIndex + 1).trim();

      if (mediaVariant === normalizedTitle) exactMedia.push(media);
      if (includeShared && mediaVariant === '') sharedMedia.push(media);
    });

    const matchedMedia = exactMedia.concat(sharedMedia);
    if (matchedMedia.length === 0) return;

    $('.slider-for-variant').slick('slickRemove', null, null, true);
    $('.desktop-slider-nav-variant').slick('slickRemove', null, null, true);
    $('.slider-nav-variant').slick('slickRemove', null, null, true);

    $.each(matchedMedia, function (_index, media) {
      const imageUrl = escapeVariantMediaAttribute(media.preview_image.src);
      const imageAlt = escapeVariantMediaAttribute(media.alt);

      $('.slider-for-variant').slick(
        'slickAdd',
        '<div><div class="item img-wrapper variant_item_img"><img src="' + imageUrl + '" loading="lazy" alt="' + imageAlt + '" class="item product_image_1"></div></div>'
      );
      $('.desktop-slider-nav-variant').slick(
        'slickAdd',
        '<div><div class="item a variant_item_img"><img src="' + imageUrl + '" loading="lazy" alt="' + imageAlt + '" class="item product_image_2"></div></div>'
      );
      $('.slider-nav-variant').slick(
        'slickAdd',
        '<div><div class="item variant_item_img"><img class="thumbnail-img product_image_3" src="' + imageUrl + '" loading="lazy" alt="' + imageAlt + '"></div></div>'
      );
    });

    $('.slider-for-variant').slick('slickGoTo', 0, true).slick('refresh').slick('setPosition');
    $('.desktop-slider-nav-variant').slick('slickGoTo', 0, true).slick('refresh').slick('setPosition');
    $('.slider-nav-variant').slick('slickGoTo', 0, true).slick('refresh').slick('setPosition');
  });
}
